<template>
  <div class="card-header">
    <div class="header-top">
      <div class="resource_icon">
        <i class="bi bi-link" />
      </div>
      <div
        v-if="resourceDataFormats.length && resource.href.dataformat && resource.href.dataformat.length>0"
        class="resource_format"
      >
        {{ resourceDataFormats.find(el => el.codename === resource.href.dataformat).codename }}
      </div>
      <div class="resource_name" :title="resource.href.href">
        {{ resource.href.href }}
      </div>
    </div>
    <div>
      <div class="form-row">
        <div class="form-group col-6">
          <label
            class="required"
            style="margin-top: 1em;"
          >
            {{ $t('resource.format.label') }}
          </label>
          <p class="label-help">
            {{ $t('resource.format.help') }}
          </p>
          <ValidatedFileFormatSelector
            validation-name="Format Href"
            :init-value="newResource.format"
            :format-filter="newResource.format"
            @select="$event => newResource.format = $event"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-12">
          <label>
            {{ $t('resource.url.label') }}:
          </label>
          <input
            v-model="newResource.href"
            v-sanitize
            class="form-control"
            :placeholder="resource && resource.href ? resource.href.href : 'https://'"
          >
        </div>
      </div>
      <div 
        v-if="resource.href.dataformat.indexOf('ogc-') !== -1 && newResource.format 
          && newResource.format.codename.indexOf('ogc-') !== -1"
        class="form-row" 
      >
        <ogs-maps
          id="webcomp"
          vue3d="false"
          style="display: hidden;"
        />
        <div class="form-group col-12">
          <label>
            Sélectionner une couche:
          </label>
          <Multiselect
            v-model="selectedLayer"
            :options="layerList"
            track-by="Name"
            placeholder="Sélectionner une couche"
            :custom-label="customLabel"
            :searchable="false"
            @select="selectLayer($event)"
          />
          <label>
            Nom de la couche sélectionnée:
          </label>
          <input
            v-model="newResource.layername"
            v-sanitize
            class="form-control"
            :placeholder="resource && resource.href.layername ? resource.href.layername : 'layer name'"
          >
        </div>
      </div>
      <div 
        v-if="resource.href.dataformat.indexOf('ogc-') !== -1 && newResource.format 
          && newResource.format.codename.indexOf('ogc-') !== -1"
        class="form-row" 
      >
        <div class="form-group col-12">
          <label>
            bbox
          </label>
          <input
            v-model="newResource.bbox"
            v-sanitize
            class="form-control"
            :placeholder="resource && resource.href.bbox ? resource.href.bbox : 'bbox'"
          >
        </div>
      </div>
      <div class="resource-form-footer">
        <slot name="publication" />
        <b-button
          variant="outline-secondary"
          :disabled="!canUpdateResource"
          @click="modifyHref"
        >
          {{ $t('buttons.update') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import ValidatedFileFormatSelector from '@/common/components/ValidatedFileFormatSelector.vue';

export default {
  name: 'HrefEditor',

  components: {
    ValidatedFileFormatSelector,
    Multiselect
  },

  props: {
    isMain: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => {}
    },
  },

  data () {
    return {
      loading: false,
      initiating: true,
      hideState: true,
      selectedLayer: null,
      layerList: [],
      newResource:{
        href: null,
        format: null,
        layername: null,
        bbox: null,
      },
    };
  },

  computed: {
    ...mapState('resources', [
      'resourceDataFormats'
    ]),
    ...mapState('datasets', [
      'currentDataset'
    ]),

    canUpdateResource() {
      return this.newResource.format && (this.newResource.href||this.newResource.layername||this.newResource.bbox);
    }
  },

  watch: {
  },

  async created() {
    if (this.resource.href.dataformat && this.resource.href.dataformat.length>0) {
      this.newResource.format = this.resourceDataFormats.find(el => el.codename === this.resource.href.dataformat);
    }

  },
  async mounted() {
    if (this.resource.href.dataformat.indexOf('ogc-') !== -1 && this.newResource.format && this.newResource.format.codename.indexOf('ogc-') !== -1) {
      const webcomponent = document.getElementById('webcomp');
        
      const mapComponent = webcomponent.vueComponent;
      const headers = {};
      if(this.resource.href && this.resource.href.href) {
        let self = this;
        mapComponent.capabilitiesService.getCapabilities(this.resource.href.href, headers, true)
          .subscribe(
            (data) => {
              console.log(data);
              self.resultList = data;
              if (self.resultList !== null) {
                self.layerList = self.resultList.layers;
              }
            },
            (error) => {
              console.log(error);
            },
          );
      }
    }

  },


  methods: {
    selectLayer(layer) {
      if (layer) {
        console.log(layer);

        if(layer.Identifier){//WMTS case
          this.newResource.layername = layer.Identifier;
          let bbox = layer.WGS84BoundingBox;
          if (bbox) {
            for (let i = 0; i < bbox.length; i += 1) {
              bbox[i] = +bbox[i].toFixed(3);
            }
          } else {
            bbox = [-180.0, -90.0, 180.0, 90.0];
          }
          this.newResource.bbox = bbox.join(',');
        }else{
          this.newResource.layername = layer.Name;
          if(layer.EX_GeographicBoundingBox){
            this.newResource.bbox = layer.EX_GeographicBoundingBox.join(',');
          }
          else{
            this.newResource.bbox = layer.BoundingBox.find(x=>x.crs=='CRS:84'||x.crs=='EPSG:4326').extent.join(',');
          }
        }
        
        
      } else {
        this.newResource.layername = null;
      }
    },
    customLabel(option) {
      return `${option.Title} (${option.Name || option.Identifier})`;
    },
    modifyHref() {
      this.resource[this.resource.type].dataformat= this.newResource.format.codename;
      this.resource[this.resource.type].layername= this.newResource.layername;
      this.resource[this.resource.type].bbox= this.newResource.bbox;
      if(this.newResource.href){
        this.resource[this.resource.type].href= this.newResource.href;
      }
      
      this.$emit('modify', {
        data: undefined,
        resource:this.resource,
      });
    },
  }
};
</script>

<style lang="less" scoped>
.resource-form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 1em 1em;
  .form-check {
    margin-left: 5px;
  }
  button.btn-primary {
    border: 2px solid #9BD0FF;
    border-radius: 8px;
    margin-left: 1.5em;
  }
  button.btn-outline-secondary {
    background-color: #F7F8FA;
    border: 2px solid #A9B2B9;
    border-radius: 8px;
    color: #2F3234;
  }
  button.btn-outline-secondary:not(.disabled) {
    color: white;
    background-color: #4b4b4b;
  }
}
.resource-form-footer.space-between {
  justify-content: space-between;
}
</style>